module.exports = "<p>\n  admin-page-home works!\n</p>\n"